<template>
  <div id="footer">
    <v-footer
      :dark="fData.dark"
      :padless="fData.padless"
      :absolute="fData.absolute"
      :fixed="fData.fixed"
    >
      <!-- <pre>{{ fData }}</pre> -->
      <v-card flat tile class="text-center primary">
        <div id="footer-one" v-if="fData.footerOne">
          <v-card-text v-if="fData.socialIcons">
            <v-btn
              v-for="icon in fData.socials"
              :key="icon.id"
              class="mx-4 white--text"
              icon
              :href="icon.link"
              target="_blank"
            >
              <v-icon size="24px">{{ icon.icon_img_code }}</v-icon>
            </v-btn>
          </v-card-text>

          <v-card-text class="white--text pt-0">{{ fData.footerOneText }}</v-card-text>

          <v-divider></v-divider>
        </div>
        <div id="footer-two" v-if="fData.footerTwo">
          <v-card-text class="white--text">
            {{ new Date().getFullYear() }} —
            <strong>Vuetify</strong>
          </v-card-text>
        </div>
      </v-card>
    </v-footer>
  </div>
</template>

<script>
export default {
  data: () => ({
    icons: ['mdi-facebook', 'mdi-twitter-circle', 'mdi-linkedin', 'mdi-instagram'],
  }),
  computed: {
    fData() {
      return this.$store.state.initialTestData.tequsDocument.info.theme.theme_setup.footer;
    },
  },
};
</script>
